import { z } from "zod";
export const zVehicleManufacturerCommonSchema = z.object({
    id: z.string(),
    name: z.string(),
});
export const zVehicleManufacturerFiltersSchema = z.object({
    search: z.string().optional(),
});
